import React from 'react'

import CardWithButtons from 'pages/Dashboard/cards/shared/CardWithButtons'

import { color } from 'styles/colors'

type Props = {
  criticalSdaCount: number | string
  sdaMajorAlertCount: number | string
  sdaMinorAlertCount: number | string
  dirtyFilterCount: number | string
  isLoaded: boolean
}

const SdaAlertsCard = ({ criticalSdaCount, sdaMajorAlertCount, sdaMinorAlertCount, dirtyFilterCount, isLoaded }: Props) => {
  const criticalSdaButton = {
    text: 'Critical SDAs',
    img: '/img/critical_sda_alert.svg',
    imgAlt: 'SDA Critical SDA Alert',
    quantity: criticalSdaCount || 0,
    accentColor: color('criticalSdaAlert'),
    apptentiveEventName: 'view_critical_sda_alerts_customers',
    gaEventName: 'Critical SDA Alerts',
    filter: 'sda_critical',
    tooltip: 'Total number of "critical" SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const majorSdaButton = {
    text: 'Major SDAs',
    img: '/img/major_sda_alert.svg',
    imgAlt: 'SDA Major SDA Alert',
    quantity: sdaMajorAlertCount,
    accentColor: color('majorSdaAlert'),
    apptentiveEventName: 'view_sda_major_alerts_customers',
    gaEventName: 'SDA Major Alerts',
    filter: 'sda_major',
    tooltip: 'Total number of "major" SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const minorSdaButton = {
    text: 'Minor SDAs',
    img: '/img/minor_sda_alert.svg',
    imgAlt: 'SDA Minor SDA Alert',
    quantity: sdaMinorAlertCount,
    accentColor: color('minorSdaAlert'),
    hasStripedAccentColor: true,
    apptentiveEventName: 'view_sda_minor_alerts_customers',
    gaEventName: 'SDA Minor Alerts',
    filter: 'sda_minor',
    tooltip: 'Total number of "minor" SDA alerts identified on registered or opted-in customers\' systems.'
  }

  const dirtyFilterButton = {
    text: 'Dirty Air Filters\n SDA.006.03',
    img: '/img/dirty_air_filter.svg',
    imgAlt: 'Dirty Air Filter',
    quantity: dirtyFilterCount,
    accentColor: color('dirtyFilter'),
    apptentiveEventName: 'view_dirty_filter_alerts_customers',
    gaEventName: 'Dirty Air Filter Alerts',
    filter: 'dirty_filter',
    tooltip: 'Total number of "dirty air filter" alerts identified on registered or opted-in customers\' systems.'
  }

  return (
    <CardWithButtons
      title={SdaAlertsCard.cardTitle}
      description="Smart Diagnostics Alerts (SDA) are based on algorithms that run periodically in the cloud and are independent of the alerts triggered within the thermostat or HVAC equipment."
      image="/img/SDA.png"
      buttons={[criticalSdaButton, majorSdaButton, minorSdaButton, dirtyFilterButton]}
      videoKey="sdas"
      isLoaded={isLoaded}
      hehmEnabled={false}
    />
  )
}

SdaAlertsCard.cardTitle = 'SDAs'
SdaAlertsCard.cardKey = 'sda_alerts'

export default SdaAlertsCard
